<template>
  <div class="mainContainer">
    <div class="nav">
      <div class="navContainer" style="width: 250px">
        <p style="display:inline-block;width:60px">品牌：</p>
        <el-select v-model="brand" filterable multiple size="mini"
                   style="margin-left:0px;width:100%" collapse-tags placeholder="请选择品牌">
          <el-option v-for="item in brandOptions" :key="item.id" :label="item.brand"
                     :value="item.id"/>
        </el-select>
      </div>
      <div class="navBtn">
        <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
        <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
      </div>
    </div>
    <div class="content">
      <div class="tableContainer">
        <el-table
          v-loading="tableLoad"
          :data="TableData"
          border stripe
          style="width: 100%"
          class="nowrap-tab"
          :cell-style="{'color':'#7F7F7F','font-size':'13px','height':'52px',}"
          :header-cell-style="{color:'#3B3B3B','font-size':'13px',background:'#E8E8E8'}">
          <el-table-column prop="departurePlace" label="品牌" width="150" align="center">
            <el-table-column prop="departurePlace" label="港口" align="center"
                             width="150"></el-table-column>
          </el-table-column>
          <el-table-column v-for="(th,index) in TableTh" :key="index" :label="th" :property="th"
                           show-overflow-tooltip align="center" :render-header="labelHead"/>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import {highwayStatList, getModelList} from "@/service/vehiclelog"

export default {
  data() {
    return {
      brand: '',  // 品牌查询条件
      brandOptions: [], // 品牌列表
      tableLoad: false,  // 表格加载状态
      TableTh: [], // 表头
      TableData: [], // 列表数据
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    async init() {
     // await this._highwayStatList();
      await this._getModelList();
    },
    // 分页查询
    async _highwayStatList() {
      const obj = {
        modelId: this.brand.length > 0 ? this.brand.join(',') : '',
      };
      this.tableLoad = true;
      const res = await highwayStatList(obj);
      if (res.status !== 0) return this.$message.error(res.message);
      this.TableTh = [], this.TableData = [];
      this.TableTh = res.data.hang;
      this.TableTh.push('合计');
      if (res.data.higWayList && res.data.higWayList.length > 0) {
        res.data.higWayList.forEach((item, index) => {
          this.TableData.push({
            departurePlace: item.departurePlace,
            departurePlaceId: item.departurePlaceId
          });
          if (this.TableTh.length > 0) {
            this.TableTh.forEach(tem => {
              this.TableData[index][tem] = 0;
            })
          }
          let total = 0;
          if (item.carQuantity.length > 0) {
            item.carQuantity.forEach(data => {
              this.TableData[index][data.modelName] = data.carNumber;
              total += data.carNumber;
            })
          }
          this.TableData[index]['合计'] = total;
        });
      }
      this.tableLoad = false;
    },
    // 获取品牌
    async _getModelList() {
      let res = await getModelList();
      if (res.status !== 0) return this.$message.error(res.message);
      this.brandOptions = res.data;
    },

    // 表头宽度
    labelHead(h, data) {
      // 不换行显示全部
      // let l = column.label.length;
      // let f = 14;
      // if(l > 10) { column.width = f*(l - 4); }
      // else { column.width = f*(l + 3); }
      // return h('div',{class:'table-head',style:{width:'100%',fontWeight:700}},[column.label]);
      // 不换行，超出显示...
      return h("span", [
        h(
          "el-tooltip",
          {
            attrs: {
              class: "item",
              effect: "dark",
              content: data.column.label,
              placement: "top",
            },
            style: {
              width: '100%',
              fontWeight: 700,
              display: 'inline-block',
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
              overflow: 'hidden',
              verticalAlign: 'bottom'
            },
          },
          [h("span", data.column.label)]
        ),
      ]);
    },
    // 查询
    searchBtn() {
      this._highwayStatList();
    },
    // 重置
    resetBtn() {
      this.brand = '';
    },
  },
};
</script>


<style lang="scss" scoped>
.mainContainer {
  width: 100%;
  padding: 20px 15px 0 25px;

  .line {
    width: 12px;
    height: 32px;
    background-color: rgba(51, 84, 131, 100);
    margin-right: 10px;
  }

  .line + span {
    font-size: 16px;
    color: rgba(51, 84, 131, 100);
    font-weight: 600;
  }

  .nav {
    width: 100%;
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    &Container {
      width: 200px;
      display: flex;
      align-items: center;
      margin-right: 5px;
      margin-bottom: 5px;

      p {
        font-size: 14px;
        color: rgba(16, 16, 16, 100);
      }
    }

    ::v-deep {
      label.el-form-item__label {
        font-weight: 500;
        color: #101010;
      }
    }

    &Btn {
      display: flex;
      align-items: center;
      margin-bottom: 5px;
    }
  }

  .content {
    display: flex;
    flex-direction: column;
    align-items: center;

    .tableContainer {
      margin-top: 15px;
      margin-bottom: 25px;
      width: 100%;

      ::v-deep {
        .el-table .cell {
          padding: 0;
        }

        .el-table th {
          padding: 0 5px;
        }

        .el-table td {
          padding: 0;
        }
      }
    }

    .paginationContainer {
      margin-right: auto;
      display: flex;
      align-items: center;
      margin-bottom: 20px;

      span {
        font-size: 13px;
      }
    }
  }

  ::v-deep {
    .el-table th > .cell {
      font-weight: 700 !important;
    }
  }
}

::v-deep {
  .el-select__tags-text {
    display: inline-block;
    max-width: 90px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .el-select .el-tag__close.el-icon-close {
    top: -5px;
  }

  // 表头斜杠
  .el-table thead.is-group th {
    background: none;
    padding: 0px;
  }

  .el-table thead.is-group tr:first-of-type th:first-of-type {
    border-bottom: none; // 中间的横线去掉
  }

  .el-table thead.is-group tr:first-of-type th:first-of-type div.cell {
    text-align: right; // 上边文字靠右
    padding-right: 20%;
  }

  .el-table thead.is-group tr:last-of-type th:first-of-type div.cell {
    text-align: left; // 下边文字靠左
    padding-left: 20%;
  }

  // 核心代码
  .el-table thead.is-group tr:first-of-type th:first-of-type:before {
    content: "";
    position: absolute;
    width: 1px;
    height: 100px; // 斜线的长度
    top: 0;
    left: 0;
    background-color: grey;
    opacity: 0.2;
    display: block;
    transform: rotate(-43deg); // 调整斜线的角度
    transform: rotate(-70deg); // 调整斜线的角度
    -webkit-transform-origin: top;
    transform-origin: top;
  }

  .el-table thead.is-group tr:last-of-type th:first-of-type:before {
    content: "";
    position: absolute;
    width: 1px;
    height: 100px; // 斜线的长度
    bottom: 0;
    right: 0;
    background-color: grey;
    opacity: 0.2;
    display: block;
    transform: rotate(-45deg); // 调整斜线的角度
    transform: rotate(-70deg); // 调整斜线的角度
    -webkit-transform-origin: bottom;
    transform-origin: bottom;
  }

  .el-table thead.is-group th {
    height: 27.4px;
  }
}
</style>
